import { DynamicData, updateDynamicData } from '@kaltura-ott/tvpil';
import { lastValueFrom } from 'rxjs';

export const languagePlayerSet = async ({ key, value }: DynamicData) => {
  return lastValueFrom(updateDynamicData({ key, value }));
};
